import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';

import {
  Link, StickyNav,
} from '@powdr/components';
import { AppContext } from '@powdr/context';
import { useSeason } from '@powdr/hooks';
import {
  getActiveLinkAtSetDepth, getLevelLink, getLevelName,
} from '@powdr/utils';
import { useStaticData } from '@powdr/web/src/hooks';

import { BackButton } from './components';
import {
  StyledPageTitle, StyledPageHeader, ThirdLevelNav,
  InnerWrapper,
  AlignmentWrapper,
  StickyNavWrapper,
} from './styles';

export const PageHeader = ({
  title = '',
  showStickyNav,
  backButtonLink = null,
  levels,
}) => {
  const { navigationDrawer: { navigation } } = useStaticData();
  const { isMobile } = useContext(AppContext);
  const { checkSeasonality } = useSeason();

  const stickyNav = useMemo(
    () => getActiveLinkAtSetDepth(navigation?.childPages, levels, 1)?.childPages
      ?.filter((page) => !page.isHideFromNav && checkSeasonality(page.season)) || [],
    [checkSeasonality, levels, navigation],
  );

  const showThirdLevelNav = !(
    getActiveLinkAtSetDepth(stickyNav, levels, 2)?.isOpenChildrenInModals
    || getActiveLinkAtSetDepth(stickyNav, levels, 2)?.isShowBackBtnOnChildren
    || stickyNav.length === 0
  );

  const pageNav = useMemo(
    () => (
      (showThirdLevelNav)
        ? getActiveLinkAtSetDepth(stickyNav, levels, 2)
          ?.childPages
          ?.filter((page) => !page.isHideFromNav && checkSeasonality(page.season)) || []
        : []
    ),
    [checkSeasonality, levels, stickyNav, showThirdLevelNav],
  );

  return (
    <>
      <StickyNavWrapper>
        {(showStickyNav) && (
          <StickyNav
            levels={levels}
            data={stickyNav}
            mobileInnerNavData={pageNav}
          />
        )}
      </StickyNavWrapper>
      <StyledPageHeader id="page-header">
        <InnerWrapper>
          <AlignmentWrapper className="alignment-wrapper">
            { !!(title) && (<StyledPageTitle>{title}</StyledPageTitle>)}
            {(!isMobile && pageNav.length > 1) && (
              <ThirdLevelNav
                id="third-level-nav" // do not change, needed for tracking
              >
                <ul>
                  { pageNav.map((levelThreeItem) => (
                    <li className="t-item" key={levelThreeItem.id}>
                      { getLevelLink(levelThreeItem).includes(`/${levels[2]}`) && (
                      <Link
                        className={classNames('btn', { 'm-active': getLevelLink(levelThreeItem).endsWith(`/${levels[2]}`) })}
                        href={getLevelLink(levelThreeItem)}
                      >
                        {getLevelName(levelThreeItem)}
                      </Link>
                      )}
                      { !getLevelLink(levelThreeItem).includes(`/${levels[2]}`) && (
                      <Link
                        // TODO: find all m-active and btn classes and convert to styled components
                        className={classNames('btn', { 'm-active': getLevelLink(levelThreeItem).includes(`/${levels[0]}/${levels[1]}/${levels[2]}`) })}
                        href={getLevelLink(levelThreeItem)}
                      >
                        {getLevelName(levelThreeItem)}
                      </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </ThirdLevelNav>
            )}
            {(backButtonLink) && (
              <BackButton backButtonLink={backButtonLink} />
            )}
          </AlignmentWrapper>
        </InnerWrapper>
      </StyledPageHeader>
    </>
  );
};

PageHeader.propTypes = {
  backButtonLink: PropTypes.string,
  showStickyNav: PropTypes.bool.isRequired,
  levels: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
};
